import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import client from '../client';
import { parseEnvelope } from '../envelope';

const acceptedGrantSchema = z.object({
  grant_id: z.string().uuid(),
  owner_display_name: z.string(),
  tax_year: z.number().int(),
  scope: z.literal('business_only'),
}).strict();

export const invitationAcceptSchema = z.object({
  grant: acceptedGrantSchema,
  destination: z.string().min(1),
}).strict();

export type InvitationAccept = z.infer<typeof invitationAcceptSchema>;

export function useAcceptInvitation() {
  return useMutation({
    mutationFn: async ({ token }: { token: string }) => {
      const response = await client.post('/api/accountant-invitations/accept', { token });
      return parseEnvelope(invitationAcceptSchema, response.data).data;
    },
  });
}
